import { useContext } from "react";
import PropTypes from "prop-types";
import { ClientConfigurationContext } from "../../context/ClientConfigurationContextProvider";

export default function PageHeader({
    header,
    subHeader,
    children,
    showBottomBorder,
    icon,
    backgroundColor,
    numberOfAlerts
}) {
    let clientConfiguration = useContext(ClientConfigurationContext);
    let style = {};

    if (backgroundColor) {
        style.backgroundColor = backgroundColor;
    }

    return (
        <div className="page-header--wrapper" style={style}>
            {clientConfiguration.enableAlerts && numberOfAlerts > 0 &&
                <div className="row" style={{ backgroundColor: '#F3A241', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <b>You have {numberOfAlerts} alert{numberOfAlerts > 1 && "s"}.</b>
                </div>
            }
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className={`page-header${showBottomBorder ? " page-header-bottom-border" : ""}${subHeader ? "" : " page-header--without-subheader"}`}>
                            <div className="page-header-left">
                                {header && <h2>{header}</h2>}
                                {subHeader && <h4>{subHeader}</h4>}
                                {children}
                            </div>
                            {icon &&
                                <div className="page-header-right">
                                    <span className={`geico-icon ${icon} pull-right`}></span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PageHeader.propTypes = {
    header: PropTypes.node,
    subHeader: PropTypes.node,
    children: PropTypes.node,
    showBottomBorder: PropTypes.bool,
    icon: PropTypes.string,
    backgroundColor: PropTypes.string,
    numberOfAlerts: PropTypes.number
};
